module.exports = __webpack_public_path__ + "img/70d3bf5b179b30e00c2a99b9c4d64ed0.svg";